// extracted by mini-css-extract-plugin
export var closeButton = "_mz-2";
export var closeButtonIcon = "_mz-3";
export var lightboxContent = "_mz-1";
export var lightboxOverlay = "_mz-0";